export enum Operator {
  and = 'and',
  or = 'or',
  not = 'not',
  eq = 'eq',
  ne = 'ne',
  gt = 'gt',
  ge = 'ge',
  lt = 'lt',
  le = 'le',
  in = 'in',
  notIn = 'not in',
}

export enum OperandType {
  literal = 'literal',
  function = 'function',
  nested = 'nested',
}

export type LiteralOperand = { literal: boolean };
export type FunctionOperand = { function: string };
export type NestedOperand = { operator: Operator; operands: Operand[] };

export type Operand = LiteralOperand | FunctionOperand | NestedOperand;

export enum TransportationBenefitModelState {
  active = 'active',
  inactive = 'inactive',
  draft = 'draft',
}

export interface TransportationBenefitModel {
  transportationBenefitModelUUID?: string;
  name: string;
  expression: Operand;
  state?: TransportationBenefitModelState;
  modifiedByUserID?: string;
  modifiedDateTimeUTC?: string;
  correlationUUID?: string;
}

export interface ClientTransportationBenefit {
  clientBC: string;
  transportationBenefitUUID: string;
}
